import { createSelector } from 'reselect';

import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  FETCH_SELECTED_QUESTION: 'FETCH_SELECTED_QUESTION',
  FETCH_SELECTED_QUESTION_SUCCESS: 'FETCH_SELECTED_QUESTION_SUCCESS',
  FETCH_SELECTED_QUESTION_FAILED: 'FETCH_SELECTED_QUESTION_FAILED',
  UPDATE_SELECT_QUESTION: 'UPDATE_SELECT_QUESTION',
  READ_CURRENT_QUESTION: 'READ_CURRENT_QUESTION',
  READ_CURRENT_QUESTION_SUCCESS: 'READ_CURRENT_QUESTION_SUCCESS',
  READ_CURRENT_QUESTION_FAILED: 'READ_CURRENT_QUESTION_FAILED',
  GO_TO_QUESTION_CHATROOM_BY_ID: 'GO_TO_QUESTION_CHATROOM_BY_ID',
};

export const fetchSelectedQuestion = (QID) => ({
  type: types.FETCH_SELECTED_QUESTION,
  payload: { QID },
});

export const fetchSelectedQuestionSuccess = (question) => ({
  type: types.FETCH_SELECTED_QUESTION_SUCCESS,
  payload: { question },
});

export const fetchSelectedQuestionFailed = (errorMessage) => ({
  type: types.FETCH_SELECTED_QUESTION_FAILED,
  payload: { errorMessage },
});

export const updateSelectQuestion = (question) => ({
  type: types.UPDATE_SELECT_QUESTION,
  payload: { question },
});

export const readSelectedQuestion = () => ({
  type: types.READ_CURRENT_QUESTION,
});

export const readSelectedQuestionSuccess = () => ({
  type: types.READ_CURRENT_QUESTION_SUCCESS,
});

export const readSelectedQuestionFailed = (errorMessage) => ({
  type: types.READ_CURRENT_QUESTION_FAILED,
  payload: { errorMessage },
});

export const goToQuestionChatroomByID = (questionID) => ({
  type: types.GO_TO_QUESTION_CHATROOM_BY_ID,
  payload: { questionID },
});

const INIT_STATE = {
  errorMessage: '',
  loadingStatus: loadingState.EMPTY,
  id: 0,
  data: {}, // selected question, serve as a buffer for selected question.
};

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case types.FETCH_SELECTED_QUESTION:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
        id: parseInt(action.payload.QID, 10),
        data: {},
      };
    case types.FETCH_SELECTED_QUESTION_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        data: action.payload.question,
      };
    case types.FETCH_SELECTED_QUESTION_FAILED:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
        errorMessage: action.payload.errorMessage,
      };
    case types.UPDATE_SELECT_QUESTION:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.question,
        },
      };
    case types.READ_CURRENT_QUESTION:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case types.READ_CURRENT_QUESTION_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
      };
    case types.READ_CURRENT_QUESTION_FAILED:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
        errorMessage: action.payload.errorMessage,
      };
    case types.GO_TO_QUESTION_CHATROOM_BY_ID:
      return {
        ...state,
        id: action.payload.questionID,
      };
    default:
      return state;
  }
}

export const getSelectedQuestion = (state) => state.chat.selectQuestion.data;
export const getSelectedQuestionID = (state) => state.chat.selectQuestion.id;
export const getAasmState = createSelector(
  getSelectedQuestion,
  (question) => question.aasm_state
);

export const getAskedBy = createSelector(
  getSelectedQuestion,
  (question) => question.asked_by || {}
);

export const getIsEnableTaggingMessage = createSelector(
  getSelectedQuestion,
  (question) => question.is_subtopic_taggable || false
);

export const getSubtopicTaggableDeadline = createSelector(
  getSelectedQuestion,
  (question) => question.subtopic_taggable_deadline || undefined
);

export const getAnsweredBy = createSelector(
  getSelectedQuestion,
  (question) => question.answered_by || {}
);



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/selectQuestion.js